import React, { PropTypes } from 'react';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';

const TimeSpanSelect = ({ timeSpan, onTimeSpanChange, ...other }) => (
  <DropDownMenu
    {...other}
    value={timeSpan}
    onChange={(e, i, value) => onTimeSpanChange(value)}
    autoWidth
  >
    <MenuItem value="now" primaryText="Nykyhetki" />
    <MenuItem value="recent" primaryText="Viimeiset 24h" />
    <MenuItem value="future" primaryText="Tulevat 7 päivää" />
  </DropDownMenu>
);

TimeSpanSelect.propTypes = {
  timeSpan: PropTypes.string.isRequired,
  onTimeSpanChange: PropTypes.func.isRequired,
};

export default TimeSpanSelect;



// WEBPACK FOOTER //
// ./src/components/TimeSpanSelect/TimeSpanSelect.js